
import union from 'lodash/union';

import { initInstance, registerModule, serverApi } from './core';

import { ModuleData } from './data';
import { ModuleMap } from './map';
import { ModuleMeasurement } from './measurement';
import { ModuleMultiScene } from './multiscene';
import { ModuleMapMultiScene } from './mapmultiscene';
import { ModulePrint } from './print';
import { ModuleProject } from './project';
import { ModuleSearch } from './search';
import { ModuleShare } from './share';

import { Log } from './core';
const log = Log.getLogger('MultiSceneForApp.init');

const MODULE_DATA = 'data';
const MODULE_MAP = 'map';
const MODULE_MEASUREMENT = 'measurement';
const MODULE_MULTISCENE = 'multiscene';
const MODULE_MAPMULTISCENE = 'mapmultiscene';
const MODULE_PRINT = 'print';
const MODULE_PROJECT = 'project';
const MODULE_SEARCH = 'search';
const MODULE_SHARE = 'share';

const MODULES = {
    [MODULE_DATA]: ModuleData,
    [MODULE_MAP]: ModuleMap,
    [MODULE_MEASUREMENT]: ModuleMeasurement,
    [MODULE_MULTISCENE]: ModuleMultiScene,
    [MODULE_MAPMULTISCENE]: ModuleMapMultiScene,
    [MODULE_PRINT]: ModulePrint,
    [MODULE_PROJECT]: ModuleProject,
    [MODULE_SEARCH]: ModuleSearch,
    [MODULE_SHARE]: ModuleShare
};

/**
 * Options for initialize library MultiSceneForApp.
 *
 * @typedef {Object} MultSceneForApp~options
 * @property {Array} modules - list of modules for initialize (map, measurement, multiscene, mapmultiscene, print, search, share)
 * @property {string} serverApiUrl - URL for call server API
 * @property {string} [projectId] - define used project
 * @property {MultSceneForApp~optionsMultiScene} [multiscene] - options for loading MultiSceneCore library
 */

 /**
 * Options for initialize library MultiSceneCore.
 *
 * @typedef {Object} MultSceneForApp~optionsMultiScene
 * @property {string} license - license used for loading MultiSceneCore library
 * @property {string} version - version of used MultiSceneCore library
 */

/**
 * Initializes the library. This function MUST be called before any code from library is used.
 *
 * @param {MultSceneForApp~options} options - options for library initialize
 * @param {function()} callback - callback function called after library initialize
 */
export default async function init(options, callback) {
    options = options || {};
    let modules = options.modules || [
        MODULE_DATA, MODULE_MAP, MODULE_MULTISCENE, MODULE_MAPMULTISCENE,
        MODULE_MEASUREMENT, MODULE_PRINT, MODULE_PROJECT, MODULE_SHARE
    ];

    modules = union(modules, [MODULE_PROJECT]);

    try {
        initInstance();

        serverApi.init(options);

        for (let i = 0; i < modules.length; i++) {
            let moduleClass = MODULES[modules[i]];
            if (moduleClass) {
                let module = new moduleClass();
                if (module && module.init) {
                    await module.init(options);
                    registerModule(module);
                }
            }
        }

        callback(null, true);
    } catch (e) {
        log.error(e);
        callback(new Error('initialization failed'), false);
    }
}
